import { footerLinks } from '@/mocks/downloadData';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 px-4 md:px-8 pt-14 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading text-2xl tracking-wide text-background-50">啪啪视频</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              啪啪视频app下载与最新地址导航页。整理官网入口、手机版安装包与备用线路，
              方便你快速找到可用地址，随时选择下载或在线访问。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-900 text-accent-400 text-xl">
                <i className="ri-time-line"></i>
              </span>
              <div className="text-xs text-background-200 leading-relaxed">
                页面地址不定期更新
                <br />
                建议收藏本页便于随时回访
              </div>
            </div>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-lg text-background-50 tracking-wide">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5 gap-x-4">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="inline-flex items-center gap-1.5 text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-lg text-background-50 tracking-wide">下载提示</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-secondary-400 mt-0.5"></i>
                优先使用本站整理的官方安装包
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-secondary-400 mt-0.5"></i>
                安装前确认存储空间充足
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-secondary-400 mt-0.5"></i>
                遇到问题先查看常见问题
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © 2026 啪啪视频下载导航 · 本页仅整理下载与入口信息
          </p>
          <p className="text-xs text-background-300">
            内容仅供访问参考，请合理安排上网时间
          </p>
        </div>
      </div>
    </footer>
  );
}